import { Injectable } from '@angular/core';
import { BackendService } from '@tg4/http-infrastructure/dist/src';
import { Observable } from 'rxjs';
import { Note } from './_interfaces/note.interface';

@Injectable()
export class NotepadService {

  constructor(private _httpService: BackendService) { }

  public getUserNotes(): Observable<any> {
    return this._httpService.get('getUserNotes');
  }

  public getAllUserNotes(): Observable<any> {
    return this._httpService.get('getAllUserNotes');
  }

  public addNote(text: string): Observable<any> {
    return this._httpService.post('addNote', {
      'text': text
    });
  }

  public updateNote(note: Note): Observable<any> {
    return this._httpService.put('updateNote', note);
  }

  public deleteNote(noteId: number): Observable<any> {
    return this._httpService.delete('deleteNote', [
      { 'name': 'id', 'value': noteId as any }
    ]);
  }

  public getAllSubordinatesNotes(): Observable<any> {
    return this._httpService.get('getAllUsers');
  }

  public getSubordinatesNotes(): Observable<any> {
    return this._httpService.get('getSubordinatesNotes');
  }

  public addSubordinateNote(text: string, userId: string, all: boolean): Observable<any> {
    if (all) {
      return this._httpService.post('addAllSubordinatesNotes', {
        'text': text,
        'subjectUserId': userId
      });
    }
    return this._httpService.post('addSubordinateNote', {
      'text': text,
      'subjectUserId': userId
    });
  }


}
